import moment from "moment";

import { Client } from "@seneca/client-library";

import { UserXp } from "./types";

export default class XpServiceClient extends Client {
  async fetchXP(courseId?: string) {
    const url = `${this.url}/api/xp/me?date="${moment().toISOString()}"${
      courseId ? `&courseId="${courseId}"` : ""
    }`;

    const response = await this.requestMaker.makeRequest(url, {
      method: "GET"
    });

    return response.json as UserXp;
  }
}
